import type { FetchMenuTopRowProps, JaneDM } from '@iheartjane/dm-sdk';
import { useCallback } from 'react';

import type { AlgoliaProduct } from '@jane/search/data-access';
import type { MenuCategoryPath } from '@jane/shared/types';

import type { UseFetchPlacementProps } from './useFetchPlacement';
import { useFetchPlacement } from './useFetchPlacement';

interface UseMenuTopRowInnerProps {
  pageCategory?: MenuCategoryPath;
}

type UseMenuTopRowProps = Omit<
  UseFetchPlacementProps<FetchMenuTopRowProps<object>>,
  'dependencies'
> &
  UseMenuTopRowInnerProps;

export const useMenuTopRowNoRefresh = <
  ProductShape extends object = AlgoliaProduct,
>(
  props: UseMenuTopRowProps
) => {
  const { pageCategory, searchFilter, enabled, storeId, searchAttributes } =
    props;

  const dependencies = [searchFilter, pageCategory, storeId];

  const fetchPlacement = useCallback(async (sdk: JaneDM) => {
    return await sdk.fetchMenuTopRow<ProductShape>({
      searchAttributes,
      searchFilter,
      storeId: Number(storeId),
    });
  }, dependencies);

  return useFetchPlacement({ dependencies, enabled }, fetchPlacement);
};
